import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { sentenceStructureData, getDataForDifficulty } from '../courses/data/grammar/sentenceStructure';

export default function SentenceStructureTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : sentenceStructureData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
